import React, { useEffect, useState } from "react";
import { SparkIcon } from "./Icons";

const STEPS = [
  "Understanding your question…",
  "Querying tender data…",
  "Checking stage movements and dates…",
  "Matching team leads and members…",
  "Crunching the numbers…",
  "Writing your report…",
];

/** Typing indicator with rotating status text and elapsed time. */
export default function Thinking({ startedAt }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(t);
  }, []);
  const elapsed = Math.max(0, Math.floor((now - startedAt) / 1000));
  const step = STEPS[Math.min(Math.floor(elapsed / 4), STEPS.length - 1)];
  return (
    <div className="bdai-msg bdai-msg-bot" aria-live="polite">
      <div className="bdai-avatar bdai-avatar-pulse"><SparkIcon size={15} /></div>
      <div className="bdai-bubble bdai-bubble-bot bdai-thinking">
        <span className="bdai-dots" aria-hidden="true">
          <i /><i /><i />
        </span>
        <span className="bdai-thinking-text">{step}</span>
        <span className="bdai-thinking-time">{elapsed}s</span>
      </div>
    </div>
  );
}
